<template>
  <div>
    <a
        href="javascript:;"
        data-toggle="modal"
        id="modal-success-reset"
        style="display: none"
        data-target="#success-modal-reset"
        class="button inline-block bg-theme-1 text-white"
    ></a>
    <div id="success-modal-reset" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <CheckCircleIcon
              class="w-16 h-16 text-theme-9 mx-auto mt-3"
          />
          <div class="text-gray-600 mt-2">
            {{modalText}}
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
              @click="redirectToLogin"
          >
            Login
          </button>
        </div>
      </div>
    </div>
    <div class="flex items-center mt-8">
    </div>
    <!-- BEGIN: Wizard Layout -->
    <div v-if="isValid" class="intro-y box py-10 sm:py-20 mt-5">
      <div class="px-5 mt-10">
        <div class="font-medium text-center text-lg">Change your password</div>
<!--        <div class="text-gray-600 text-center mt-2">-->
<!--          To start off, please enter your username, email address and password.-->
<!--        </div>-->
      </div>
      <div
          class="px-5 sm:px-20 mt-10 pt-10 border-t border-gray-200 dark:border-dark-5"
      >
        <div class="grid grid-cols-12 gap-4 row-gap-5 mt-5">
          <div class="intro-y col-span-12 sm:col-span-6">
            <div class="mb-2">New password</div>
            <input
                v-model="newPassword"
                type="password"
                class="input w-full border flex-1"
            />
          </div>
          <div class="intro-y col-span-12 sm:col-span-6">
            <div class="mb-2">Confirm password</div>
            <input
                v-model="confirmPassword"
                type="password"
                class="input w-full border flex-1"
            />
            <br/>
            <br/>
            <div
                v-if="infoError === true "
                class="rounded-md flex items-center px-5 py-4 mb-2 bg-theme-6 text-white"
            >
              <AlertOctagonIcon class="w-6 h-6 mr-2" />
              Confirm password not matched
            </div>
          </div>
          <div
              class="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5"
          >
            <button
                class="button w-24 justify-center block bg-theme-1 text-white ml-2"
                :disabled="newPassword !== confirmPassword"
                @click="handleSubmit"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="intro-y box py-10 sm:py-20 mt-5">
      <div class="px-5 mt-10">
        <div class="font-medium text-center text-lg">This link was expired. Please return to reset form and sent new email</div>
        <!--        <div class="text-gray-600 text-center mt-2">-->
        <!--          To start off, please enter your username, email address and password.-->
        <!--        </div>-->
      </div>
      <div class="text-center">
        <router-link to="/reset-form">
          <button
              type="button"
              class="button inline-block bg-theme-1 text-white"
          >
            To reset form
          </button>
        </router-link>
      </div>
    </div>
    <br />
    <!-- END: Wizard Layout -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      config: {
        headers: {
          Authorization: "false",
        }
      },
      infoError: false,
      modalText: "",
      newPassword: null,
      confirmPassword: null,
      isValid: true
    }
  },
  watch: {
    confirmPassword() {
      if (this.newPassword !== this.confirmPassword) {
        this.infoError = true
      } else {
        this.infoError = false
      }
      if (this.confirmPassword.length < 1 || this.confirmPassword === null) {
        this.infoError = false
      }
    }
  },
  mounted() {
    this.checkTokenExpire()
  },
  methods: {
    redirectToLogin() {
      this.$router.push("/login")
    },
    checkTokenExpire() {
      axios
          .post("reset-password/verify-token/", {
            token: this.$route.params.token
          }, this.config)
          .then(response => {
            if (response.data.status !== "OK") {
              this.isValid = false
            }
          })
          .catch(function(error) {
            console.error(error.response);
            // self.infoError = true
          });
    },
    handleSubmit(e) {
      console.log("submit")
      e.preventDefault();
      if (this.newPassword === this.confirmPassword) {
        axios
            .post("reset-password/verify-token/", {
              token: this.$route.params.token,
              password: this.newPassword
            }, this.config)
            .then(response => {
              if (response.data.status === "OK") {
                this.modalText = "Password success changed"
                document.getElementById("modal-success-reset").click()
                // this.$router.push("/login")
              }
            })
            .catch(function(error) {
              console.error(error.response);
              // self.infoError = true
            });
      } else {
        this.infoError = true
      }
    }
  }
};
</script>
